import classNames from 'classnames';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BrandS } from '@sorare/core/src/atoms/typography';

const Root = styled.div`
  position: relative;
  opacity: 0;

  &.show {
    opacity: 1;

    &::after {
      content: '';
      display: block;
      position: absolute;
      inset: 0;
      opacity: 0;
      background: var(--c-nd-500);
      filter: blur(12px);
    }
  }
`;

type Props = { show: boolean; message: MessageDescriptor };
export const NewCardTag = ({ show, message }: Props) => {
  return (
    <Root className={classNames({ show })}>
      <BrandS className="text-color-contrast">
        <FormattedMessage {...message} />
      </BrandS>
    </Root>
  );
};
